module.exports = __webpack_public_path__ + "img/b6.5a97fc92.jpeg";